var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Left Sidebar
 */
import React, { useMemo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
// import { IoMdFlash } from 'react-icons/io'
import { usePackageManagement, usePackingState } from '../../../hooks/packing';
// import { CreateContainerDropdown } from './CreateContainerDropdown'
import { PackageDetailsModal } from '../modals/PackageDetailsModal';
import { PackingTreeView } from './PackingTreeView';
import { MdAdd, MdPallet } from 'react-icons/md';
export var LeftSidebar = function (_a) {
    var selectedPackageKey = _a.selectedPackageKey, selectedContainerKey = _a.selectedContainerKey, virtualPackages = _a.virtualPackages, virtualContainers = _a.virtualContainers, containerList = _a.containerList, containerLinkedPackageSeqIds = _a.containerLinkedPackageSeqIds, onPackageSelect = _a.onPackageSelect, onContainerSelect = _a.onContainerSelect, onNewPackage = _a.onNewPackage, onNewContainer = _a.onNewContainer, onAddChildContainer = _a.onAddChildContainer, 
    // onBulkPackClick,
    // onBulkContainerClick,
    onContainerClose = _a.onContainerClose, onContainerReopen = _a.onContainerReopen, onContainerDelete = _a.onContainerDelete, onContainerReset = _a.onContainerReset, onBulkPack = _a.onBulkPack, onDeleteVirtualPackage = _a.onDeleteVirtualPackage, onDeleteVirtualContainer = _a.onDeleteVirtualContainer, _b = _a.palletDisabled, palletDisabled = _b === void 0 ? false : _b, palletDisabledTooltip = _a.palletDisabledTooltip;
    var t = useTranslation().t;
    var _c = React.useState(false), browseModalVisible = _c[0], setBrowseModalVisible = _c[1];
    var getAllPackagesInfo = usePackageManagement().getAllPackagesInfo;
    var _d = usePackingState(), boxTypes = _d.boxTypes, shipmentItemDetailList = _d.shipmentItemDetailList, productSkuUpcList = _d.productSkuUpcList, packageContentBySeqId = _d.packageContentBySeqId, packageSerialNumbersBySeqId = _d.packageSerialNumbersBySeqId, containerTypeList = _d.containerTypeList, loadBoxTypes = _d.loadBoxTypes;
    var serializedProductIds = useMemo(function () {
        var serializedIds = new Set();
        productSkuUpcList.forEach(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.serialized) === 'Y' && (item === null || item === void 0 ? void 0 : item.productId)) {
                serializedIds.add(item.productId);
            }
        });
        shipmentItemDetailList.forEach(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.serialized) === 'Y' && (item === null || item === void 0 ? void 0 : item.productId)) {
                serializedIds.add(item.productId);
            }
        });
        return serializedIds;
    }, [productSkuUpcList, shipmentItemDetailList]);
    var realPackages = useMemo(function () { return getAllPackagesInfo(); }, [getAllPackagesInfo]);
    var packageItems = useMemo(function () {
        var virtualItems = virtualPackages.map(function (virtualPackage) {
            var mappedBoxType = boxTypes.find(function (boxType) { return boxType.key === virtualPackage.shipmentBoxTypeId; });
            return {
                key: "virtual:" + virtualPackage.tempId,
                kind: 'virtual',
                displayId: t('New Package') + " " + virtualPackage.displayPackageNumber,
                virtualTempId: virtualPackage.tempId,
                shipmentBoxTypeId: virtualPackage.shipmentBoxTypeId,
                boxTypeDescription: mappedBoxType === null || mappedBoxType === void 0 ? void 0 : mappedBoxType.value,
                isClosed: false,
                itemCount: 0
            };
        });
        var realItems = realPackages.map(function (pkg) { return ({
            key: "real:" + pkg.shipmentPackageSeqId,
            kind: 'real',
            displayId: "#" + pkg.shipmentPackageSeqId,
            shipmentPackageSeqId: pkg.shipmentPackageSeqId,
            shipmentBoxTypeId: pkg.shipmentBoxTypeId,
            boxTypeDescription: pkg.boxTypeDescription,
            isClosed: pkg.isClosed,
            itemCount: pkg.itemCount,
            hasSerializedItems: (packageSerialNumbersBySeqId[pkg.shipmentPackageSeqId] || []).length > 0 ||
                (packageContentBySeqId[pkg.shipmentPackageSeqId] || []).some(function (item) {
                    return serializedProductIds.has(item.productId);
                })
        }); });
        return __spreadArray(__spreadArray([], realItems, true), virtualItems, true);
    }, [
        boxTypes,
        realPackages,
        t,
        virtualPackages,
        packageSerialNumbersBySeqId,
        packageContentBySeqId,
        serializedProductIds
    ]);
    useEffect(function () {
        if (boxTypes.length === 0) {
            void loadBoxTypes();
        }
    }, [boxTypes.length, loadBoxTypes]);
    var handlePackageSelect = useCallback(function (item) {
        if (item.kind === 'real' && item.shipmentPackageSeqId) {
            onPackageSelect({ kind: 'real', seqId: item.shipmentPackageSeqId }, item.isClosed);
        }
        else if (item.kind === 'virtual' && item.virtualTempId) {
            onPackageSelect({ kind: 'virtual', tempId: item.virtualTempId }, false);
        }
        setBrowseModalVisible(false);
    }, [onPackageSelect]);
    var handleSelectBySeqId = useCallback(function (seqId) {
        var _a;
        var existingPackage = realPackages.find(function (realPackage) { return realPackage.shipmentPackageSeqId === seqId; });
        onPackageSelect({ kind: 'real', seqId: seqId }, (_a = existingPackage === null || existingPackage === void 0 ? void 0 : existingPackage.isClosed) !== null && _a !== void 0 ? _a : false);
        setBrowseModalVisible(false);
    }, [onPackageSelect, realPackages]);
    // const handleNewPackage = useCallback(
    //   (boxTypeId?: string) => {
    //     onNewPackage(boxTypeId)
    //   },
    //   [onNewPackage]
    // )
    var containerTypeMap = useMemo(function () {
        var map = new Map();
        containerTypeList.forEach(function (ct) { return map.set(ct.enumId, ct.description); });
        return map;
    }, [containerTypeList]);
    return (_jsxs("div", __assign({ className: 'bg-white rounded-xl shadow-sm flex flex-col h-full min-h-0 w-full overflow-hidden' }, { children: [_jsx("div", __assign({ className: 'flex-1 min-h-0' }, { children: _jsx(PackingTreeView, { packageItems: packageItems, containerList: containerList, virtualContainers: virtualContainers, containerLinkedPackageSeqIds: containerLinkedPackageSeqIds, containerTypeMap: containerTypeMap, selectedPackageKey: selectedPackageKey, selectedContainerKey: selectedContainerKey, onPackageSelect: handlePackageSelect, onContainerSelect: onContainerSelect, onContainerClose: onContainerClose, onContainerReopen: onContainerReopen, onContainerDelete: onContainerDelete, onContainerReset: onContainerReset, onAddChildContainer: onAddChildContainer, onBulkPack: onBulkPack, onDeleteVirtualPackage: onDeleteVirtualPackage, onDeleteVirtualContainer: onDeleteVirtualContainer }, void 0) }), void 0), _jsxs("div", __assign({ className: 'flex flex-col gap-2 border-t border-gray-200 p-3' }, { children: [_jsxs("div", __assign({ className: 'grid grid-cols-2 gap-2' }, { children: [_jsxs("button", __assign({ type: 'button', className: 'flex items-center justify-center gap-1.5 text-primary font-semibold px-3 py-2 rounded-lg border border-gray-300 bg-white hover:bg-blue-50 transition-colors', style: { fontSize: 12 }, onClick: function () { return onNewContainer('CtCarton'); } }, { children: [_jsx(MdAdd, { style: { fontSize: 16, flexShrink: 0 } }, void 0), t('Carton')] }), void 0), _jsx(Tooltip, __assign({ title: palletDisabled ? palletDisabledTooltip : '' }, { children: _jsx("span", __assign({ className: 'inline-block w-full' }, { children: _jsxs("button", __assign({ type: 'button', disabled: palletDisabled, className: "flex w-full items-center justify-center gap-1.5 px-3 py-2 rounded-lg border font-semibold transition-colors " + (palletDisabled
                                            ? 'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'border-gray-300 bg-white text-primary hover:bg-blue-50'), style: { fontSize: 12 }, onClick: function () { return onNewContainer('CtPallet'); } }, { children: [_jsx(MdPallet, { style: { fontSize: 16, flexShrink: 0 } }, void 0), t('Pallet')] }), void 0) }), void 0) }), void 0)] }), void 0), _jsxs("button", __assign({ type: 'button', className: 'flex items-center justify-center gap-1.5 text-gray-600 font-semibold px-3 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 transition-colors', style: { fontSize: 12 }, onClick: function () { return setBrowseModalVisible(true); } }, { children: [_jsx(SearchOutlined, { style: { fontSize: 12 } }, void 0), t('Package Details')] }), void 0)] }), void 0), _jsx(PackageDetailsModal, { visible: browseModalVisible, onClose: function () { return setBrowseModalVisible(false); }, onPackageSelect: handleSelectBySeqId }, void 0)] }), void 0));
};
export default LeftSidebar;
